import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-loan-settlement-negotiation-accept-pop-up',
  templateUrl: './loan-settlement-negotiation-accept-pop-up.component.html',
  styleUrls: ['./loan-settlement-negotiation-accept-pop-up.component.css']
})
export class LoanSettlementNegotiationAcceptPopUpComponent implements OnInit {

  private readonly dialogRef: MatDialogRef<LoanSettlementNegotiationAcceptPopUpComponent>;

  constructor(
    dialogRef: MatDialogRef<LoanSettlementNegotiationAcceptPopUpComponent>) {
    this.dialogRef = dialogRef;
  }

  ngOnInit(): void {
  }

  decline(): void {
    this.dialogRef.close(true);
  }

}
